import { toValue } from 'vue'
import { defineStore } from 'pinia'
import Campaign from '@/classes/campaigns/Campaign'
import Campaigns from '@/classes/campaigns/Campaigns'
import Statistics from '@/classes/statistics/Statistics'

export const useCampaignStore = defineStore('CampaignStore', {
  state: () => ({
    campaigns: {},
    campaign: {},
    statistics: {},
    loader: false,
    error: {}
  }),
  getters: {
    getCampaigns: state => ({ query, dependencies } = {}) => state.$getItems({
      resource: 'campaigns',
      query,
      dependencies,
      fetch: () => state.fetchCampaigns({ query })
    }),
    getCampaign: state => ({ id }) => state.$getItem({
      resource: 'campaign',
      key: id,
      fetch: () => state.fetchCampaign({ id })
    }),
    getStatistics: state => ({ id, dependencies, multi_currency = true }) => state.$getItem({
      resource: 'statistics',
      key: id,
      dependencies,
      multi_currency,
      fetch: () => state.fetchStatistics({ id, multi_currency })
    })
  },
  actions: {
    fetchCampaigns ({ query }) {
      return this.$fetchItems({
        endpoint: '/api/v1/campaigns',
        resource: 'campaigns',
        model: Campaigns,
        query
      })
    },
    async fetchCampaign ({ id }) {
      await this.$pipeline({ dependencies: [id] })

      return this.$fetchItem({
        endpoint: `/api/v1/campaigns/${toValue(id)}`,
        resource: `campaign.${toValue(id)}`,
        model: Campaign
      })
    },
    async fetchStatistics ({ id, multi_currency = true }) {
      await this.$pipeline({ dependencies: [id] })

      return this.$fetchItem({
        endpoint: `/api/v1/campaigns/${toValue(id)}/statistics`,
        resource: `statistics.${toValue(id)}`,
        model: Statistics,
        multi_currency
      })
    }
  }
})